import { useState } from 'react';
import Header from './components/layout/Header';
import MobileMenu from './components/layout/MobileMenu';
import Hero from './components/sections/Hero';
import About from './components/sections/About';
import Leadership from './components/sections/Leadership';
import Events from './components/sections/Events';
import GrowthGroups from './components/sections/GrowthGroups';
import WeCare from './components/sections/WeCare';
import Sermons from './components/sections/Sermons';
import Contact from './components/sections/Contact';
import Footer from './components/layout/Footer';
import BackToTop from './components/common/BackToTop';

function App() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="font-sans bg-[#0a0f1e] text-gray-100">
      <Header
        isMobileMenuOpen={isMobileMenuOpen}
        setIsMobileMenuOpen={setIsMobileMenuOpen}
      />

      <MobileMenu
        isOpen={isMobileMenuOpen}
        closeMenu={() => setIsMobileMenuOpen(false)}
      />

      <main>
        <Hero />
        <About />
        <Leadership />
        <Events />
        <GrowthGroups />
        <WeCare />
        <Sermons />
        <Contact />
      </main>

      <Footer />
      <BackToTop />
    </div>
  );
}

export default App;
